import { generateUtilityClasses } from '@mui/material';

export const selectClasses = generateUtilityClasses('Select', [
  'root',
  'icon',
  'menu',
  'menuItem',
  'placeholder',
]);
